import axios from 'axios';

/** 新しい nearest-td 要求で直前の GET をキャンセル */
let nearestTDCancelSource = null;

export const ERROR_LIST_TUNNEL_STATION_POINT = '[CTM LANDING] ERROR LIST TUNNEL STATION POINT - DISTANCE';
export const ERROR_LIST_TUNNEL_STATION_POINT_DESIGN = '[CTM LANDING] ERROR LIST TUNNEL STATION POINT DESIGN - DISTANCE';
export const LIST_TUNNEL_STATION_POINT = '[CTM LANDING] LIST TUNNEL STATION POINT - DISTANCE';
export const LIST_TUNNEL_STATION_POINT_DESIGN = '[CTM LANDING] LIST TUNNEL STATION POINT DESIGN - DISTANCE';
export const LIST_DISTANCE_FACE  = '[CTM LANDING] LIST DISTANCE FACE';
export const LIST_DISTANCE_INVERT  = '[CTM LANDING] LIST DISTANCE INVERT';
export const LIST_MEASUREMENT_POINT = '[CTM LANDING] LIST MEASUREMENT POINT';
export const PATTERN_GROUP_LIST = '[CTM LANDING] PATTERN GROUP LIST';
export const PATTERN_GROUP_DESIGN_LIST = '[CTM LANDING] PATTERN GROUP DESIGN LIST';
export const GET_NEAREST_TD = '[CTM LANDING] GET NEAREST TD';
export const GET_NEXT_NEAREST_TD = '[CTM LANDING] GET NEXT NEAREST TD';
// export const GET_PREV_NEAREST_TD = '[CTM LANDING] GET NEXT NEAREST TD';
export const GET_PREV_NEAREST_TD = '[CTM LANDING] GET PREV NEAREST TD';
export const GET_TFAS_ACCESS_TOKEN = '[CTM LANDING] GET TFAS ACCESS TOKEN';
export const GET_CCTV_URL = '[CTM LANDING] GET PROJECT CCTV URL';
export const RESET_CTM = '[CTM LANDING] RESET CTM';
export const REMOTE_VIEW_POINT = '[CTM LANDING] REMOTE VIEW POINT';
export const TUNNEL_DISTANCE_PROGRESS = '[CTM LANDING]  TUNNEL DISTANCE PROGRESS';
export const LINING_INVERT_BAND_SEGMENTS = '[CTM LANDING] LINING INVERT BAND SEGMENTS';
export const GET_PROJECT_EXTRA_URLS = '[CTM LANDING] GET PROJECT EXTRA URLS';

/** レスポンス適用時点で同じ工事コードが選択されているか（遅延レスポンスでストアを汚染しない） */
function isSelectedCtmProject(getState, projectCode) {
    if (projectCode == null || projectCode === '') {
        return false;
    }
    const selected = getState()?.members?.members?.handleMembers_projectSelected;
    if (!selected || typeof selected !== 'object') {
        return false;
    }
    return selected.projectCode === projectCode;
}

export const listPatternGroup = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    
    try {

        const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/pattern-group-list?const_cd='+projectCode, {
            headers: { Authorization: `Token ${token}` }
        });

        return request.then(response => {
            console.log("PATTERN_GROUP_LIST ===============> ", response)
            if (response.data) {
                if (!isSelectedCtmProject(getState, projectCode)) {
                    return;
                }
                return dispatch({
                    type: PATTERN_GROUP_LIST,
                    data: response.data.data,
                });
            } else {
                //reject(response.data.error);
            }
        }).catch(function (error) {
            console.log("error PATTERN_GROUP_LIST ===============> ", error)
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
            // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: ERROR_LIST_TUNNEL_STATION_POINT,
            });
        
        })
    } catch (err) {
        console.error("Error response 404 :");
        console.error(err.response.data);
    }

   
};

export const listPatternGroupDesign = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    
    try {
        console.log("listPatternGroupDesign : " + process.env.REACT_APP_SERVER + '/api/ctm/pattern-group-design-list?const_cd='+projectCode)
        const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/pattern-group-design-list?const_cd='+projectCode, {
            headers: { Authorization: `Token ${token}` }
        });

        return request.then(response => {
            console.log("PATTERN_GROUP_DESIGN_LIST ===============> ", response)
            if (response.data) {
                if (!isSelectedCtmProject(getState, projectCode)) {
                    return;
                }
                return dispatch({
                    type: PATTERN_GROUP_DESIGN_LIST,
                    data: response.data.data,
                });
            } else {
                //reject(response.data.error);
            }
        }).catch(function (error) {
            console.log("error PATTERN_GROUP_DESIGN_LIST ===============> ", error)
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
            // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: ERROR_LIST_TUNNEL_STATION_POINT_DESIGN,
            });
        
        })
    } catch (err) {
        console.error("Error response 404 :");
        console.error(err.response.data);
    }
};


export const listTunnelStationPoint = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    console.log('listTunnelStationPoint start ===============> ', projectCode)
    try {

        const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/td-list?const_cd='+projectCode, {
            headers: { Authorization: `Token ${token}` }
        });

        return request.then(response => {
            if (response.data) {
            console.log('listTunnelStationPoint response ===============> ', response.data.data)
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: LIST_TUNNEL_STATION_POINT,
                data: response.data.data,
            });
            } else {
                //reject(response.data.error);
            }
        }).catch(function (error) {
            console.log("error listTunnelStationPoint ===============> ", error)
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
            // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: ERROR_LIST_TUNNEL_STATION_POINT,
            });
        
        })

    } catch (err) {
        console.error("Error response 404 :");
        console.error(err.response.data);
    }

   
};

export const listTunnelStationPointDesign = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    console.log('listTunnelStationPointDesign start ===============> ', projectCode)
    try {

        const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/td-design-list?const_cd='+projectCode, {
            headers: { Authorization: `Token ${token}` }
        });

        return request.then(response => {
            if (response.data) {
            console.log('listTunnelStationPoint response ===============> ', response.data.data)
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: LIST_TUNNEL_STATION_POINT_DESIGN,
                data: response.data.data,
            });
            } else {
                //reject(response.data.error);
            }
        }).catch(function (error) {
            console.log("error listTunnelStationPointDesign ===============> ", error)
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
            // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: ERROR_LIST_TUNNEL_STATION_POINT_DESIGN,
            });
        
        })

    } catch (err) {
        console.error("Error response 404 :");
        console.error(err.response.data);
    }

   
};


export const listDistanceFace = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/upper-lower-face-position?const_cd='+projectCode, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        if (!isSelectedCtmProject(getState, projectCode)) {
            return;
        }
        return dispatch({
            type: LIST_DISTANCE_FACE,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const listDistanceInvert = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/lining-invert-face-position?const_cd='+projectCode, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        if (!isSelectedCtmProject(getState, projectCode)) {
            return;
        }
        return dispatch({
            type: LIST_DISTANCE_INVERT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const listMeasurementPoint = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/measurement-point?const_cd='+projectCode, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        if (!isSelectedCtmProject(getState, projectCode)) {
            return;
        }
        return dispatch({
            type: LIST_MEASUREMENT_POINT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const getNearestTD = (projectCode, tunnelDistance) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    console.log('getNearestTD:/api/ctm/nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance);
    if (nearestTDCancelSource) {
        nearestTDCancelSource.cancel('superseded');
    }
    const source = axios.CancelToken.source();
    nearestTDCancelSource = source;
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
        headers: { Authorization: `Token ${token}` },
        cancelToken: source.token,
    });

    return request.then(response => {
        console.log('NEAREST TD:', response.data.data)
        if (response.data.data) {
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: GET_NEAREST_TD,
                data: response.data.data,
            });
        } else {
        //reject(response.data.error);
            console.log('NO NEAREST TD WAS FOUND')
        }
    }).catch((err) => {
        if (axios.isCancel(err)) {
            return;
        }
        console.log('getNearestTD error', err);
    }).finally(() => {
        if (nearestTDCancelSource === source) {
            nearestTDCancelSource = null;
        }
    });
};

export const getNextNearestTD = (projectCode, tunnelDistance, tfasTunnelDist, faceBasicNumber, fileName) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let url = process.env.REACT_APP_SERVER + '/api/ctm/next-nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance;
    if(tfasTunnelDist) {
        url += '&tfas_tunnel_dist='+tfasTunnelDist;
    } else if(faceBasicNumber) {
        url += "&face_basic_number="+faceBasicNumber;
    }
    if(fileName) {
        url += '&image_file_name='+fileName;
    }
    console.log('url :', url);
    // const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/next-nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
    //     headers: { Authorization: `Token ${token}` }
    // });
    const request = axios.get(url, {
        headers: {Authorization: `Token ${token}`}
    });

    return request.then(response => {
        console.log("getNextNearestTD>>>>>>>>>> ", response);
        if (response.data.data) {
            console.log('GET NEXT NEAREST TD:', response.data.data)
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: GET_NEXT_NEAREST_TD,
                data: response.data.data,
            });
        } else {
        //reject(response.data.error);
            console.log('NO NEAREST TD WAS FOUND')
        }
    });
};

export const getPrevNearestTD = (projectCode, tunnelDistance, tfasTunnelDist, faceBasicNumber, fileName) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let url = process.env.REACT_APP_SERVER + '/api/ctm/prev-nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance;
    if(tfasTunnelDist) {
        url += '&tfas_tunnel_dist='+tfasTunnelDist;
    } else if(faceBasicNumber) {
        url += "&face_basic_number="+faceBasicNumber;
    }
    if(fileName) {
        url += '&image_file_name='+fileName;
    }
    console.log('url :', url);
    // console.log('getPrevNearestTD:/api/ctm/prev-nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance);
    // const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/prev-nearest-td?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
    //     headers: { Authorization: `Token ${token}` }
    // });
    const request = axios.get(url, {
        headers: {Authorization: `Token ${token}`}
    });
    
    return request.then(response => {
        console.log("getPrevNearestTD>>>>>>>>>> ", response);
        if (response.data.data) {
            console.log('GET PREV NEAREST TD:', response.data.data)
            if (!isSelectedCtmProject(getState, projectCode)) {
                return;
            }
            return dispatch({
                type: GET_PREV_NEAREST_TD,
                data: response.data.data,
            });
        } else {
        //reject(response.data.error);
            console.log('NO NEAREST TD WAS FOUND')
        }
    });
};


export const resetCTM = () => async dispatch => {

    return dispatch({
        type: RESET_CTM,
    });

};


export const remoteViewPoint = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/remote-view-point?const_cd='+projectCode, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        if (!isSelectedCtmProject(getState, projectCode)) {
            return;
        }
        return dispatch({
            type: REMOTE_VIEW_POINT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const getTFASAccessToken = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/tfas-access-token?const_cd='+projectCode, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        if (!isSelectedCtmProject(getState, projectCode)) {
            return;
        }
        return dispatch({
            type: GET_TFAS_ACCESS_TOKEN,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const getCCTVURL = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    try {
      console.log('DEBUG! CCTVURL projectCode OK:', projectCode);
      const request = axios.get(`${process.env.REACT_APP_SERVER}/api/ctm/cctv-url?const_cd=${projectCode}`, {
        headers: { Authorization: `Token ${token}` },
      });
   
      return request
        .then((response) => {
          console.log('DEBUG! CCTV URL response:', response.data);
          if (response.data.data) {
            if (!isSelectedCtmProject(getState, projectCode)) {
              return;
            }
            return dispatch({
              type: GET_CCTV_URL,
              cctv_url: response.data.data,
            });
          } else {
            console.log('DEBUG! response is OK but NO CCTVURL');
          }
        })
        .catch((error) => {
          console.log('DEBUG! CCTVURL NO Response:', error);
        });
    } catch (err) {
      console.error('DEBUG! CCTVURL projectCode ERROR:', err);
    }
  };

export const getTDProgress = (projectCode, tunnelDistance) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    try {
        const formatDate = (date, sep="") => date.getFullYear() + sep + ('00' + (date.getMonth()+1)).slice(-2) + sep +('00' + date.getDate()).slice(-2);
        const today = new Date();
        const dateStrSlash = formatDate(today, "/");
        const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/td-progress?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance+'&const_date='+dateStrSlash, {
        //console.log('getTDProgress:'+process.env.REACT_APP_SERVER + '/api/ctm/td-progress?const_cd='+projectCode+'&target_date='+dateStrSlash);
        //console.log('DEBUG! getTDProgress OK:', `${process.env.REACT_APP_SERVER}/api/ctm/td-progress?const_cd=${projectCode}`);
        //const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/td-progress?const_cd=XKT555552&tunnel_dist='+tunnelDistance+'&const_date='+dateStrSlash, {
                headers: { Authorization: `Token ${token}` }
            });
        return request.then(response => {
            console.log(response.data.data);
            if (response.data.data) {
                console.log('[getTDProgress]GET TUNNEL DISTANCE PROGRESS:', response.data.data)
                if (!isSelectedCtmProject(getState, projectCode)) {
                    return;
                }
                return dispatch({
                    type: TUNNEL_DISTANCE_PROGRESS,
                    data: response.data.data,
                });
            } else {
            //reject(response.data.error);
                console.log('[getTDProgress]NO TUNNEL DISTANCE PROGRESS ', response.data.error)
            }
        })
        .catch((error) => {
            console.log('DEBUG! getTDProgress NO Response:', error);
          });
      } catch (err) {
        console.error('DEBUG! getTDProgress ERROR:', err);
      }
    };

export const getLiningInvertBandSegments = (projectCode) => async (dispatch, getState) => {
    const current_user = JSON.parse(localStorage.getItem('current_user'));
    const token = current_user['authToken'];
    try {
        const request = axios.get(
            `${process.env.REACT_APP_SERVER}/api/ctm/lining-invert-band-segments?const_cd=${projectCode}`,
            { headers: { Authorization: `Token ${token}` } }
        );
        return request.then((response) => {
            if (response.data && !response.data.isError && response.data.data) {
                if (!isSelectedCtmProject(getState, projectCode)) {
                    return;
                }
                return dispatch({
                    type: LINING_INVERT_BAND_SEGMENTS,
                    data: response.data.data,
                });
            }
            if (isSelectedCtmProject(getState, projectCode)) {
                return dispatch({
                    type: LINING_INVERT_BAND_SEGMENTS,
                    data: {
                        lining_segments: [],
                        invert_segments: [],
                        lining_leading_edge_tunnel_dist: null,
                        invert_leading_edge_tunnel_dist: null,
                    },
                });
            }
        }).catch((error) => {
            console.log('getLiningInvertBandSegments error:', error);
            if (isSelectedCtmProject(getState, projectCode)) {
                return dispatch({
                    type: LINING_INVERT_BAND_SEGMENTS,
                    data: {
                        lining_segments: [],
                        invert_segments: [],
                        lining_leading_edge_tunnel_dist: null,
                        invert_leading_edge_tunnel_dist: null,
                    },
                });
            }
        });
    } catch (err) {
        console.error('getLiningInvertBandSegments ERROR:', err);
    }
};

/*
export function listDistanceFace(projectCode) {
	return async (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
        

		const config = {
			headers: { Authorization: `Token ${token}` }
		};
		const bodyParameters = {
			
		};
		
		const request = await axios.post(process.env.REACT_APP_SERVER + '/api/ctm/upper-lower-face-position/'+projectCode+'/', 
									bodyParameters,
									config                      
		)
        .then(response => {

        })
        .catch(function (error) {
            if (error.response) {
              // Request made and server responded
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            return dispatch({
                type: ERROR_API,
            });
        
        });


		return dispatch({
			type: LIST_DISTANCE_FACE,
		});
	}

}

*/

export const getProjectExtraURLs = (projectCode) => async (dispatch, getState) => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    try {
      const request = axios.get(`${process.env.REACT_APP_SERVER}/api/ctm/get-project-extra-urls?const_cd=${projectCode}`, {
        headers: { Authorization: `Token ${token}` },
      });

      return request
        .then((response) => {
          if (response.data.data) {
            if (!isSelectedCtmProject(getState, projectCode)) {
              return;
            }
            return dispatch({
              type: GET_PROJECT_EXTRA_URLS,
              data: response.data.data,
            });
          }
        })
        .catch(() => {});
    } catch (err) {
      console.error('getProjectExtraURLs error:', err);
    }
};
